export const REDUCER_NAME = "app";
export const APP_LOADING = `${REDUCER_NAME}/APP_LOADING`;
export const APP_ERROR = `${REDUCER_NAME}/APP_ERROR`;
export const SET_BOUNDARY_ERROR = `${REDUCER_NAME}/SET_BOUNDARY_ERROR`;
export const SET_DEFERRED_PROMPT = `${REDUCER_NAME}/SET_DEFERRED_PROMPT`;
export const SET_META = `${REDUCER_NAME}/SET_META`;
export const SET_URL = `${REDUCER_NAME}/SET_URL`;
export const SET_TITLE = `${REDUCER_NAME}/SET_TITLE`;
export const SET_COMPETITION_ID = `${REDUCER_NAME}/SET_COMPETITION_ID`;
